// import { initFirestore } from './FirestoreUtils'
import CustomerService from './CustomerService'
import DriverService from './DriverService'
// import IngredientService, { IngredientType } from './IngredientService'
// import OrderService, { OrderStatus } from './OrderService'
import OrganizationService from './OrganizationService'
import ReportService from './ReportService'
import MenuService from './MenuService'
import UserService from './UserService'
// import RecipeService from './RecipeService'

export default class SousChefAPI {
  // static init () {
  //   return new SousChefAPI(initFirestore())
  // }

  constructor (firestore) {
    this.db = firestore
    this.users = new UserService(this.db)
    this.organizations = new OrganizationService(this.db)
  }

  setOrganization (organizationId) {
    this.orgRef = this.db.collection('organizations').doc(organizationId)
    this.organizations.setOrganization(organizationId)
    this.customers = new CustomerService(this.orgRef)
    this.drivers = new DriverService(this.orgRef)
    this.reports = new ReportService(this.orgRef)
    this.menus = new MenuService(this.orgRef)
  }

  joinOrganization (email, organizationId) {
    this.organizations.joinOrganization(email, organizationId)
    this.setOrganization(organizationId)
  }

  async createOrganization (organization) {
    let orgId = await this.organizations.createOrganization(organization)
    for (let i = 0; i < organization.members.length; i++) {
      await this.users.addUser({ email: organization.members[i], organization: orgId })
    }
    return orgId
  }

  async updateUser (user) {
    await this.users.addUser(user)
    if (user.organization) {
      await this.organizations.ref(user.organization).members.updateMemberIfExists(user)
    }
  }

  batch () {
    return this.db.batch()
  }
}
